import { render, staticRenderFns } from "./Mock.vue?vue&type=template&id=60d043bb&"
import script from "./Mock.vue?vue&type=script&lang=js&"
export * from "./Mock.vue?vue&type=script&lang=js&"
import style0 from "./Mock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports